"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformColorToHexaString = transformColorToHexaString;
const legacy_enums_1 = require("@daytrip/legacy-enums");
function transformColorToHexaString(color) {
    switch (color) {
        case legacy_enums_1.Color.Black:
            return "#000000";
        case legacy_enums_1.Color.LowBlue:
            return "#000080";
        case legacy_enums_1.Color.LowGreen:
            return "#008000";
        case legacy_enums_1.Color.LowCyan:
            return "#008080";
        case legacy_enums_1.Color.LowRed:
            return "#800000";
        case legacy_enums_1.Color.LowMagenta:
            return "#800080";
        case legacy_enums_1.Color.Brown:
            return "#808000";
        case legacy_enums_1.Color.LightGray:
            return "#C0C0C0";
        case legacy_enums_1.Color.DarkGray:
            return "#808080";
        case legacy_enums_1.Color.HighBlue:
            return "#0000FF";
        case legacy_enums_1.Color.HighGreen:
            return "#00FF00";
        case legacy_enums_1.Color.HighCyan:
            return "#00FFFF";
        case legacy_enums_1.Color.HighRed:
            return "#FF0000";
        case legacy_enums_1.Color.HighMagenta:
            return "#FF00FF";
        case legacy_enums_1.Color.Yellow:
            return "#FFFF00";
        case legacy_enums_1.Color.White:
            return "#FFFFFF";
        default:
            return "undefined";
    }
}
//# sourceMappingURL=transformColorToHexaString.js.map